<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <b-row class="justify-content-center">
      <b-col md="7" class="mt-3">
        <b-card-group>
          <b-card id="auftrag1" ref="el">
            <div slot="header"
                 style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;">
              <b-row style="margin-left: 0px; margin-right: 0px">
                <div>
                  Serienaufgabe: <strong>{{auftrag.beleg_ex}}</strong>
                </div>
                <b-col></b-col>
                <div>
                  Anlage: <strong>{{formateAnlageDate}}</strong>
                </div>
              </b-row>
            </div>
            <b-row style="border-bottom: 1px solid #ccc!important;">
              <b-col sm="5" style="padding-right: 0px;">
                <b-form-group
                    label="Serienbeginn:"
                    label-for="start_date"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      disabled
                      v-model="task_series.start_date"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="start_date"
                      :aria-placeholder="formateStartDate"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"></datetime>

                </b-form-group>
              </b-col>
              <b-col sm="1" style="padding-left: 8px;">
              </b-col>
              <b-col sm="6">
                <b-form-group
                    label="Serienende:"
                    label-for="date2"
                >
                  <datetime
                      style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important;"
                      :disabled="isEditMode"
                      v-model="task_series.end_date"
                      input-class="form-control"
                      input-style="color: black;"
                      input-id="date2"
                      :aria-placeholder="formateDate"
                      :phrases="datetimeConfig.phrases"
                      :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                      :min-datetime="datetimeConfig.minTime"></datetime>

                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Auftragsgruppe</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAugr"
                              disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Auftrag-Wo</span>
              </b-col>
              <b-col md="2" class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAuftragKey"
                              disabled></b-form-input>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.auftrag_wo"
                              disabled></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span v-if="auftrag.art !== 'LS'">Auftrag-Was</span>
                <span v-else>Tourname</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.auftrag_was"
                              :disabled="!editMode"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2">
                <span>Hinweis</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    :disabled="!editMode"
                    type="text"
                    v-model="aufgabe.description"
                    :placeholder="aufgabe.description"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2" class="my-auto">
                <span>Maßnahme</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="aufgabe.massnahme"
                              :disabled="!editMode"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-1"  v-if="auftrag.art !== 'LS'">
              <b-col md="2">
                <span>Material</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-textarea
                    class="text-black"
                    style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; color: black !important;"
                    :disabled="!editMode"
                    type="text"
                    v-model="aufgabe.materialtext"
                    :placeholder="aufgabe.materialtext"
                    wrap="hard"
                    rows="3"
                    :max-rows="maxrows"
                >
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col md="2" class="my-auto">
                <span>Verantwortlich</span>
              </b-col>
              <b-col class="my-auto">
                <b-form-input class="form-control text-black"
                              v-model="formateAusfDurch"
                              disabled></b-form-input>
              </b-col>
              <b-col md="2" class="my-auto"  v-if="editMode">
                <b-button variant="success"  class="btn-pill font-sm" @click="showChangeKostMigr = true">
                  Ändern
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-card-group>
        <b-card class="mt-4">
          <b-row slot="header">
            <p style="margin-bottom: 0px; margin-top:2px; margin-left: 10px"><strong>Wiederholung:</strong></p>
                <b-form-select
                    style="max-width: 160px; margin-left: 12px; color: black"
                    :plain="true"
                    :options="seriesTypes"
                    v-model="task_series.series_type"
                    :disabled="!editMode"
                    size="sm">
                </b-form-select>
          </b-row>
          <b-row v-if="task_series.series_type === 'Y'">
            <b-col style="padding-right: 0px;">
              <b-form-radio v-model="seriesSubTypes['Y']" value="D" :disabled="!editMode">Stichtag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1"><span class="label-horizontal label-fc-height">Am</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.day" :options="days" style="color: black" :disabled="!editMode"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="task_series.month" :options="monthsSelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
              </b-row>
              <b-form-radio v-model="seriesSubTypes['Y']" value="WD" :disabled="!editMode">Wochentag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1"><span class="label-horizontal label-fc-height">Den</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.week" :options="weekSelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="task_series.weekday" :options="weekDaySelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
                <b-col md="1"><span class="label-horizontal label-fc-height">im</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.month" :options="monthsSelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
              </b-row>
              <b-row style="margin-top: 8px">
                <b-col md="1">
                  <div style="margin-top: 8px">Alle </div></b-col>
                <b-col md="2"><b-form-input v-model="task_series.year" style="" :disabled="!editMode" type="number"></b-form-input></b-col>
                <b-col md="4"><div style="margin-top: 8px"> Jahre ausführen.</div></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else-if="task_series.series_type === 'M'">
            <b-col>
              <b-form-radio v-model="seriesSubTypes['M']" value="D" :disabled="!editMode">Stichtag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1"><span class="label-horizontal label-fc-height">Am</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.day" :options="days" style="color: black" :disabled="!editMode"></b-form-select></b-col>
              </b-row>
              <b-form-radio v-model="seriesSubTypes['M']" value="WD" :disabled="!editMode">Wochentag</b-form-radio>
              <b-row style="padding: 8px 12px">
                <b-col md="1"><span class="label-horizontal label-fc-height">Den</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.week" :options="weekSelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
                <b-col md="3"><b-form-select v-model="task_series.weekday" :options="weekDaySelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
              </b-row>
              <b-form-group label="In folgenden Monaten:" style="margin-top: 10px">
                <b-form-checkbox-group
                    v-model="task_series.months"
                    :options="monthsSelectPlain"
                    :disabled="!editMode"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col style="padding-right: 0px;">
              <b-row >
                <b-col md="1"><span class="label-horizontal label-fc-height">Jede</span></b-col> <b-col md="2"><b-form-input v-model="task_series.num_weeks" :disabled="!editMode" style="" type="number"></b-form-input></b-col><b-col md="2"><span class="label-horizontal label-fc-height">Woche am</span></b-col>
                <b-col md="3"><b-form-select v-model="task_series.weekday" :options="weekDaySelect" style="color: black" :disabled="!editMode"></b-form-select></b-col>
              </b-row>
              <b-form-group label="In folgenden Monaten:" style="margin-top: 10px">
                <b-form-checkbox-group
                    v-model="task_series.months"
                    :options="monthsSelectPlain"
                    :disabled="!editMode"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mt-0">
          <b-row slot="header">
            <p style="margin-bottom: 0px; margin-top:2px; margin-left: 10px"><strong>Einstellungen:</strong></p>
          </b-row>
          <b-row>
            <b-col>
              <label for="close_automatic">Fertigstellungsart:</label>
              <b-form-select :options="closeAutomaticSelects" id="close_automatic"
                             v-model="task_series.close_automatic"
                             :disabled="!editMode"
                             class="mb-2 text-black"></b-form-select>
            </b-col>
            <b-col>
              <label for="close_automatic">Standartzuweisung:</label>
              <b-row>
                <b-col>
                  <b-form-input class="form-control" style="color: black"
                                v-model="defaultAllocationText"
                                disabled @click="showDefaultSelectionDialog"></b-form-input>
                </b-col>
                <b-col md="2" style="padding-left: 0px; padding-top: 5px">
                  <edit-icon v-if="editMode" title="" v-tooltip="'Anpassen'" :class="{'icon-1_5x': true, 'cursor-pointer': true}" fillColor="#2463ea" style="color: #016d03; margin-left: 4px;margin-bottom: 2px;" :size="72" @click="showDefaultSelectionDialog"></edit-icon>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="height: 1px; background-color: rgb(189 189 189);" class="mt-2 mb-3"></b-row>
          <b-row>
            <b-col>
              <div style="margin-top: 8px">Sende an mobile Geräte </div>
            </b-col>
            <b-col md="2"><b-form-input v-model="task_series.send_mobile_interval" style="" type="number" :disabled="!editMode"></b-form-input></b-col>
            <b-col md="3"><b-form-select v-model="task_series.send_mobile_interval_type" :options="sendMobileIntervalTypeSelects" style="color: black" :disabled="!editMode"></b-form-select></b-col>
            <b-col md="4"><div style="margin-top: 8px"> vor Fälligkeit der Aufgabe.</div></b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="5" class="mt-3">
        <b-card>
          <b-row style="gap: 10px">
            <b-button v-if="editMode" :disabled="!canContinue" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(true)">
              Speichern
            </b-button>
            <b-button v-if="editMode" variant="warning" class="btn-pill font-lg" v-on:click="toggleEditMode(false)">
              Abbruch
            </b-button>
            <b-button v-if="isEditMode && canHandle" variant="success" class="btn-pill font-lg" v-on:click="toggleEditMode(undefined)">
              Ändern
            </b-button>
            <b-button variant="primary" class="btn-pill font-lg" v-on:click="back">
              Zurück
            </b-button>
          </b-row>
        </b-card>
        <b-card v-if="auftrag.art !== 'LS'">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Anhänge</strong>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-list-group>
                <b-list-group-item
                    button
                    class="d-flex justify-content-between align-items-center"
                    v-for="item in attachments"
                    v-on:click="onAttachment(item.file_name, item.data_id, item.file_type)">
                  {{item.file_name}}
                  <div style="
    align-items: center;
    display: flex;">
                    <b-badge class="pt-1 pb-1 pl-2 pr-2" variant="primary" pill>
                      {{formatBytes(item.file_size)}}
                    </b-badge>
                    <!--delete-icon v-if="editMode" title="" v-tooltip="'Löschen'"
                                 :class="{'icon-1_5x': true}" fillColor="#2463ea"
                                 style="cursor: pointer; margin-right: 12px; color: #016d03; margin-left: 4px;margin-bottom: 2px;"
                                 :size="72" @click.prevent.stop="onDeleteAttachment(item)"></delete-icon-->
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="(auftrag.lat !== 0.0 && auftrag.lon !== 0.0) || editMode">
          <b-row slot="header">
            <b-col style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; padding-top: 8px">
              <strong>Position</strong>
            </b-col>
            <b-col>
              <b-row style="flex-direction: row-reverse">
                <b-button variant="success" style="margin-right: 15px" class="btn-pill font-sm"
                          @click="$refs.task_location_map.showMap()" v-if="editMode">
                  Anpassen
                </b-button>
              </b-row>
            </b-col>
          </b-row>
          <b-row style="margin-bottom: 0" v-if="auftrag.lat !== 0.0 && auftrag.lon !== 0.0">
            <b-col style="height: 250px; padding: 0; margin-bottom: 0" id="map_container"
                   ref="map_container">
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>


    <b-modal size="m" v-model="showChangeKostMigr" centered title="Verantwortlichkeit anpassen"
    >
      <b-row class="mt-2">
        <b-col>
          <v-jstree ref="js_tree" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem;"
                    class="my-tree" :data="kostMigrs"
                    @item-click="onKostMigrClicked"
                    show-checkbox></v-jstree>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="cancel">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!selectedKostMigr" variant="success" @click="setKostMigr">
          OK
        </b-button>
      </template>
    </b-modal>
    <task-location-map :lat="auftrag.lat" :lon="auftrag.lon" :geo-ref-perimeter="geoRefPerimeter" ref="task_location_map" @save-position="onChangePosition"/>
    <select-default-planning-dialog ref="select_default_planning_dialog" @default-selected="onDefaultSelected" />

  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from 'luxon'
import {
  arrayBufferToBase64,
  decryptAES,
  decryptFile,
  decryptMessages,
  decryptTodos,
  encryptAES,
  encryptFile,
  encryptServerTodos
} from "../../shared/crypto";
import AccountMultiplePlusIcon from 'vue-material-design-icons/AccountMultiplePlus.vue';
import AccountBox from 'vue-material-design-icons/AccountBox.vue';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import LanguageControl from 'mapbox-gl-controls/lib/language';
import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import VJstree from 'vue-jstree'

import FinishIcon from 'vue-material-design-icons/CheckCircle.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';

import TaskLocationMap from "@/views/auftraege/auftrag/TaskLocationMap.vue";
import SelectDefaultPlanningDialog from "@/views/aufgaben_verwaltung/SelectDefaultPlanningDialog.vue";
import EditIcon from 'vue-material-design-icons/PencilCircle.vue';


export default {
  name: "TaskSeries",
  components: {
    TaskLocationMap,
    AccountMultiplePlusIcon,
    AccountBox,
    BookOpenPageVariantIcon,
    CheckBoldIcon,
    VJstree,
    FinishIcon,
    DeleteIcon,
    SelectDefaultPlanningDialog,
    EditIcon
  },
  computed: {
    isEditMode() {
      return !this.editMode;
    },
    a_nr() {
      let base = this.auftrag.gi_augr + " / " + this.auftrag.gi_aufisn;
      if (this.auftrag.art === "DE") {
        return base;
      }
      return base + (this.auftrag.notiz_annahme !== null && this.auftrag.notiz_annahme !== "" ? " (" + this.auftrag.notiz_annahme + ")" : "");
    },
    formateStartDate() {
      if (!this.task_series.start_date) {
        return ""
      }
      let event = new Date(this.task_series.start_date.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateDate() {
      if (!this.task_series.end_date) {
        return ""
      }
      let event = new Date(this.task_series.end_date.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAnlageDate() {
      if (!this.task_series.create_date) {
        return ""
      }
      let event = new Date(this.task_series.create_date.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateFertig() {
      if (this.auftrag.fertig_datum === null) {
        return ""
      }
      let event = new Date(this.auftrag.fertig_datum.replace('Z', ''));
      let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return event.toLocaleDateString('de-DE', options);
    },
    formateAugr() {
      return this.auftrag.gi_augr + " " + this.augrName;
    },
    formateAuftragKey() {
      let splits = this.aufgabe.auftrag_key.split(".");
      if (splits.length === 2 || (splits.length === 3 && splits[2] === "")) {
        return splits[1]
      } else {
        return splits[1] + "." + splits[2]
      }
    },
    formateAusfDurch() {
      let postfix = "Kostenstelle"
      if (this.aufgabe.ausf_durch_typ === "MIGR") {
        postfix = "Mitarbeitergruppe"
      }
      return this.aufgabe.ausf_durch + " (" + postfix + ")"
    },
    canContinue() {
      if (parseInt(this.task_series.send_mobile_interval) < 0) {
        return false;
      }
      if (this.task_series.series_type === 'Y') {
        if (this.task_series.year < 1) {
          return false;
        }
        if (this.seriesSubTypes['Y'] === 'D') {
          return this.task_series.day !== -1 && this.task_series.month !== -1;
        } else {
          return this.task_series.week !== -1 && this.task_series.weekday !== -1 && this.task_series.month !== -1;
        }
      } else if (this.task_series.series_type === 'M') {
        if (this.task_series.months.length === 0) {
          return false;
        }
        if (this.seriesSubTypes['M'] === 'D') {
          return this.task_series.day !== -1;
        } else {
          return this.task_series.week !== -1 && this.task_series.weekday !== -1;
        }
      } else {
        if (this.task_series.months.length === 0) {
          return false;
        }
        return this.task_series.weekday !== -1;
      }
    },
  },
  data: () => {
    return {
      loader: undefined,
      attachments: [],
      canHandle: false,
      kostMigrs: [],
      selectedKostMigr: null,
      showChangeKostMigr: false,
      bauhofStructure: [],
      auftrag: {
        id: "testid",
        a_nehmer: "Bauhof",
        auftraggeber: "Musterhausen-Public Solutions",
        ziel: "26.01.2019",
        ziel_datum: LuxonDateTime.fromJSDate(new Date()).toISO(),
        gi_hh_aus: "9300300.55511010.2-85500",
        beleg_ex: "2019-0001",
        gi_auf_ext: "Test Sven",
        gi_match: "Forstwirtschaft",
        gi_augr: "0009",
        gi_aufisn: "000038",
        gi_memo: "Test vom Sven",
        email: "info@publicsolutions.de",
        datum: "",
        sachbearbeiter: "Administrator",
        offen: 0,
        quittung: null
      },
      aufgabe: {
        auftrag_key: "",
        ausf_durch: "",
        ausf_durch_typ: "",
      },
      augrName: "",
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      maxrows: 40,
      editMode: false,
      textBackup: undefined,
      dateBackup: undefined,
      aufExtBackup: undefined,
      massnahmeBackup: undefined,
      materialBackup: undefined,
      ausfuhrTypeBackup: undefined,
      ausfuhrBackup: undefined,
      delete_modal: false,
      userId: "",
      taskId: "",
      isBauhof: false,
      geoRefPerimeter: "",
      files: [],
      task_series: {},
      seriesTypes: [{text: "Jährlich", value: "Y"},{text: "Monatlich", value:"M"}, {text: "Wöchentlich", value: "W"}],
      seriesSubTypes: {
        "Y": "D",
        "M": "D",
        "W": ""
      },
      days: [{text: "Bitte wählen", value: -1},1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      weekSelect: [
        {text: "Bitte wählen", value: -1},
        {text: "ersten", value: 1},
        {text: "zweiten", value: 2},
        {text: "dritten", value: 3},
        {text: "vierten", value: 4},
      ],
      weekDaySelect: [
        {text: "Bitte wählen", value: -1},
        {text: "Montag", value: 1},
        {text: "Dienstag", value: 2},
        {text: "Mittwoch", value: 3},
        {text: "Donnerstag", value: 4},
        {text: "Freitag", value: 5},
        {text: "Samstag", value: 6},
        {text: "Sonntag", value: 0},
      ],
      monthsSelect: [
        {text: "Bitte wählen", value: -1},
        {text: "Januar", value: 1},
        {text: "Februar", value: 2},
        {text: "März", value: 3},
        {text: "April", value: 4},
        {text: "Mai", value: 5},
        {text: "Juni", value: 6},
        {text: "Juli", value: 7},
        {text: "August", value: 8},
        {text: "September", value: 9},
        {text: "Oktober", value: 10},
        {text: "November", value: 11},
        {text: "Dezember", value:12},
      ],
      monthsSelectPlain: [
        {text: "Januar", value: 1},
        {text: "Februar", value: 2},
        {text: "März", value: 3},
        {text: "April", value: 4},
        {text: "Mai", value: 5},
        {text: "Juni", value: 6},
        {text: "Juli", value: 7},
        {text: "August", value: 8},
        {text: "September", value: 9},
        {text: "Oktober", value: 10},
        {text: "November", value: 11},
        {text: "Dezember", value:12},
      ],
      defaultAllocationText: "",
      closeAutomaticSelects: [{text: "Manuelle Fertigstellung", value: false}, {text: "Automatische Fertigstellung", value: true}],
      sendMobileIntervalTypeSelects: [{text: "Tag(e)", value: "D"},{text: "Woche(n)", value:"W"}],

    }
  },
  created() {
    this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
    this.showLoader();
    this.$http.get(
        Server_URL + '/auftragsbuch/data/task_series/' + this.$route.params.id
    ).then(this.responseOkFetch, this.responseError)
  },
  methods: {
    showDefaultSelectionDialog() {
      console.log(this.task_series);
      this.$refs.select_default_planning_dialog.showDialog(this.task_series.default_allocation);
    },
    onDefaultSelected(def) {
      this.defaultAllocationText = def.map((list) => list.name).join(", ")
      this.task_series.default_allocation = def.map((list) => list.id).join(",")
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }

    },
    onFileClicked(message) {
      if (sessionStorage.getItem("aes") !== null) {
        this.showLoader();
        this.filename = message.data.file.name;
        this.$http.get(
            Server_URL + '/auftragsbuch/data/file_message/' + message.id + "?file_name=" + encodeURIComponent(message.data.file.name), {responseType: 'blob'}
        ).then(this.onFileOk, this.responseError)

      } else {
        window.open(Server_URL + '/auftragsbuch/data/file_message/' + message.id + "?file_name=" + encodeURIComponent(message.data.file.name), "_blank")
      }
    },
    onFileOk(response) {
      response.blob().then(blob => {
        blob.arrayBuffer().then(binary => {
          decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
            this.hideLoader();
            if (!this.isBauhof) {
              const b = new Blob([res], {type: blob.type});
              b.name = this.filename;
              const blobUrl = URL.createObjectURL(b);
              window.open(blobUrl, '_blank');
            } else {
              try {
                windowsFileService.onFile(
                    arrayBufferToBase64(res),
                    this.filename,
                    blob.type
                ).then(r => {
                  if (r && !r.Success) {
                    console.log(r)
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
            }

          }).catch(err => {
            if(!this.isBauhof) {
              this.hideLoader();
              const blobUrl = URL.createObjectURL(blob);
              window.open(blobUrl, '_blank');
            } else {
              try {
                windowsFileService.onFile(
                    arrayBufferToBase64(binary),
                    this.filename,
                    blob.type
                ).then(r => {
                  if (r && !r.Success) {
                    console.log(r)
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
            }
          })
        })
      });
    },
    onAttachment(filename, data_id, filetype) {
      if (sessionStorage.getItem("aes") !== null) {
        this.showLoader();
        this.filename = filename;
        this.$http.get(
            Server_URL + '/auftragsbuch/upload/file/' + data_id + "?file_name=" + encodeURIComponent(filename) + "&file_type=" + filetype, {responseType: 'blob'}
        ).then(this.onFileOk, this.responseError)

      } else {
        window.open(Server_URL + '/auftragsbuch/upload/file/' + data_id + "?file_name=" + encodeURIComponent(filename) + "&file_type=" + filetype, "_blank")
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    onChangePosition({lat, lon}) {
      /*this.showLoader();
      this.$http.post(
          Server_URL + '/auftragsbuch/data/av/edit_position/'+this.auftrag.id, {lat: lat, lon: lon, key: sessionStorage.getItem("aes")}
      ).then(this.responseOkTrap, this.responseError)*/
      this.auftrag.lat = lat;
      this.auftrag.lon = lon;
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
    },
    setKostMigr() {
      let ausType = "KOST";
      if (this.selectedKostMigr.node_type === "migr") {
        ausType = "MIGR"
      }
      this.aufgabe.ausf_durch_typ = ausType;
      this.aufgabe.ausf_durch = this.selectedKostMigr.text;
      this.showChangeKostMigr = false;
    },
    onKostMigrClicked(node, item, e) {
      this.selectedKostMigr = item;
    },
    computeKostMigrs(data) {
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
      let res = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type !== "user") {
          let cur = {...data[i]}
          cur.children = this.computeKostMigrs(cur.children)
          res.push(cur)
        }
      }
      return res;
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    toggleEditMode(save) {
      if (save === undefined) {
        this.textBackup = this.aufgabe.description;
        this.dateBackup = this.task_series.end_date;
        this.aufExtBackup = this.aufgabe.auftrag_was;
        this.massnahmeBackup =  this.aufgabe.massnahme;
        this.materialBackup = this.aufgabe.materialtext;
        this.ausfuhrTypeBackup = this.aufgabe.ausf_durch_typ;
        this.ausfuhrBackup = this.aufgabe.ausf_durch;
        this.seriesBackup = JSON.parse(JSON.stringify(this.task_series));
        this.seriesSubTypesBackup = JSON.parse(JSON.stringify(this.seriesSubTypes));
        this.defaultAllocationTextBackup = this.defaultAllocationText;
        this.latBackup = this.auftrag.lat;
        this.lonBackup = this.auftrag.lon;
      } else if (save === false) {
        this.aufgabe.description = this.textBackup;
        this.task_series.end_date = this.dateBackup;
        this.aufgabe.auftrag_was = this.aufExtBackup;
        this.aufgabe.massnahme = this.massnahmeBackup;
        this.aufgabe.materialtext = this.materialBackup;
        this.aufgabe.ausf_durch_typ = this.ausfuhrTypeBackup;
        this.aufgabe.ausf_durch = this.ausfuhrBackup;
        this.close_automatic = this.auftrag.aufgabe === "Y";
        this.task_series = JSON.parse(JSON.stringify(this.seriesBackup));
        this.seriesSubTypes = JSON.parse(JSON.stringify(this.seriesSubTypesBackup));
        this.defaultAllocationText = this.defaultAllocationTextBackup;
        this.auftrag.lat = this.latBackup;
        this.auftrag.lon = this.lonBackup;
        this.$nextTick(() => {
          this.showMapIfNeeded();
        });
      } else {
        this.showLoader();
        let series = {...this.task_series};
        series.months = series.months.join(",");
        series.send_mobile_interval = parseInt(series.send_mobile_interval);
        series.year = parseInt(series.year);
        series.num_weeks = parseInt(series.num_weeks);
        series.end_date = series.end_date === "" ? null : series.end_date;
        series.day = this.seriesSubTypes[series.series_type] === "D" ? series.day : -1;
        let req = {
          description: this.aufgabe.description,
          auftrag_was: this.aufgabe.auftrag_was,
          massnahme: this.aufgabe.massnahme,
          materialtext: this.aufgabe.materialtext,
          ausf_durch_typ: this.aufgabe.ausf_durch_typ,
          ausf_durch: this.aufgabe.ausf_durch,
          lat: this.auftrag.lat,
          lon: this.auftrag.lon,
          series: series,
          key: sessionStorage.getItem("aes"),
        }
        console.log(req)
        encryptAES(sessionStorage.getItem("aes"), req.description).then(res => {
          req.description = res;
          this.$http.post(
              Server_URL + '/auftragsbuch/data/task_series/'+this.auftrag.id,
              req
          ).then(this.onEditResponseOk, this.responseError)
        })
      }
      this.editMode = !this.editMode;
    },
    onEditResponseOk(response) {
      this.hideLoader();
      console.log(response)
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkFetch(response) {
      if (response.status === 200) {
        this.userId = response.body.session.id;
        let data = response.body.data;
        if (sessionStorage.getItem("aes") !== null) {
          this.decryptData(data.data.gi_memo, data.data.notiz_annahme,
              data.data.notiz_fertig,
              data.data.art, data.aufgabe.description, data.todos).then(res => {
            data.data.gi_memo = res[0];
            data.data.notiz_annahme = res[1];
            data.data.notiz_fertig = res[2];
            data.aufgabe.description = res[3];
            data.todos = res[4];
            this.setData(data);
          }).catch(e => {
            this.setData(data);
          });
        } else {
          this.setData(data);
        }
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    async decryptData(memo, annahme, fertig, art, desc, todos) {
      try {
        if (memo !== null && memo !== "") {
          memo = await decryptAES(sessionStorage.getItem("aes"), memo);
        }
      } catch (e) {
      }
      try {
        if (desc !== null && desc !== "") {
          desc = await decryptAES(sessionStorage.getItem("aes"), desc);
        }
      } catch (e) {
      }
      try {
        todos = await decryptTodos(sessionStorage.getItem("aes"), todos)
      } catch (e) {
      }
      try {
        if (annahme !== null && annahme !== "") {
          annahme = await decryptAES(sessionStorage.getItem("aes"), annahme);
        }
      } catch (e) {
      }
      try {
        if (fertig !== null && fertig !== "") {
          fertig = await decryptAES(sessionStorage.getItem("aes"), fertig);
        }
      } catch (e) {
      }
      return [memo, annahme, fertig, desc, todos]
    },
    setData(data) {
      this.auftrag = data.data;
      this.aufgabe = data.aufgabe;
      this.geoRefPerimeter = data.geo_ref_perimeter;
      this.augrName = data.augr_name;
      this.allGroups = data.all_groups;
      this.bauhofStructure = data.bauhof_structure;
      let d = JSON.parse(JSON.stringify(data.bauhof_structure));
      this.computeMitas(d);
      this.$refs.select_default_planning_dialog.init(d);
      this.kostMigrs = this.computeKostMigrs(JSON.parse(JSON.stringify(data.bauhof_structure)));
      this.task_series = data.series;
      this.task_series.months = this.task_series.months.split(",").map(Number);
      if(this.task_series.year < 0) {
        this.task_series.year = 1;
      }
      if (!this.task_series.num_weeks || this.task_series.num_weeks < 0) {
        this.task_series.num_weeks = 1;
      }
      this.computeDefaultAllocation(d);
      if (this.task_series.day === -1) {
        this.seriesSubTypes[this.task_series.series_type] = "WD";
      }
      this.hideLoader();
      this.contact = "";
      this.close_automatic = this.auftrag.aufgabe === "Y";
      this.canHandle = data.can_handle;
      this.editMode = false;

      let res = JSON.parse(sessionStorage.getItem(this.auftrag.auftraggeber));
      if (res !== null) {
        this.auftrag.auftraggeber = res.username;
      }
      if (this.auftrag.auftraggeber in this.allGroups) {
        this.auftrag.auftraggeber = this.allGroups[this.auftrag.auftraggeber];
      }

      if (this.auftrag.modul === "bk") {
        this.auftrag.auftraggeber = "Baumkontrolle";
      } else if (this.auftrag.modul === "k1") {
        this.auftrag.auftraggeber = "Spielplatzkontrolle";
      } else if (this.auftrag.modul === "k2" || this.auftrag.modul === "k4") {
        this.auftrag.auftraggeber = "GPS-Nachweis";
      } else if (this.auftrag.modul === "k3") {
        this.auftrag.auftraggeber = "Straßenkontrolle";
      } else if (this.auftrag.modul === "k5") {
        this.auftrag.auftraggeber = "Fast-Task";
      }

      res = JSON.parse(sessionStorage.getItem(this.auftrag.sachbearbeiter));
      if (res !== null) {
        this.auftrag.sachbearbeiter = res.first_name + " " + res.surname;
        this.auftrag.email = res.email;
      }
      this.$nextTick(() => {
        this.showMapIfNeeded();
      });
      this.attachments = data.attachments;
    },
    computeDefaultAllocation(allNodes){
      let allocations = this.task_series.default_allocation.split(",");
      let allocationNames = [];
      for (let i = 0; i < allocations.length; i++) {
        allocationNames.push(this.findNodeName(allNodes, allocations[i]))
      }
      // trim null values
      allocationNames = allocationNames.filter(function (el) {
        return el != null;
      });
      this.defaultAllocationText = allocationNames.join(", ");
    },
    findNodeName(nodes, needle) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === needle) {
          return nodes[i].text;
        } else if (nodes[i].children && nodes[i].children.length > 0) {
          let res = this.findNodeName(nodes[i].children, needle);
          if (res !== null) {
            return res;
          }
        }
      }
      return null;
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    back() {
      window.history.back();
    },
    responseErrorTrap(response) {
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        console.log(response);
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200 ) {
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    responseOkReload() {
      this.$http.get(
          Server_URL + '/auftragsbuch/data/task_series/' + this.$route.params.id
      ).then(this.responseOkFetch, this.responseError)
    },
    showMapIfNeeded() {
      if (this.auftrag.lat === 0.0 || this.auftrag.lon === 0.0) {
        this.map = undefined;
        return;
      } else if (this.map !== undefined) {
        this.marker.setLngLat([this.auftrag.lon, this.auftrag.lat])
        this.map.flyTo({
          center: [this.auftrag.lon, this.auftrag.lat]
        });
        this.$nextTick(() => {
          this.map.resize();
        });
        return;
      }

      mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
      this.map = new mapboxgl.Map({
        container: 'map_container',
        style: 'mapbox://styles/mapbox/outdoors-v11',
        center: [this.auftrag.lon, this.auftrag.lat],
        zoom: 18,
        minZoom: 5,
        maxPitch: 0,
        attributionControl: false
      });

      this.map.addControl(new ZoomControl(), 'bottom-right');
      const languageControl = new LanguageControl({
        language: 'de',
      });
      this.map.addControl(languageControl);

      this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

      this.marker = null;
      this.geojson = {};
      this.map.on('load', this.mapLoad);
    },
    mapLoad() {
      setTimeout(() => {
        if (this.marker === null) {
          let el = document.createElement('div');
          el.className = 'marker';

          this.marker = new mapboxgl.Marker({
            element: el,
            anchor: 'center',
          })
              .setLngLat([this.auftrag.lon, this.auftrag.lat])
              .addTo(this.map);
        }
        this.map.resize();
        this.hideLoader()
      });
    },
  }
}
</script>

<style>

.marker {
  background-image: url('../../../public/mangel_marker.png');
  background-size: cover;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
}

.sc-message {
  width: 480px;
}

.sc-message--text .sc-message--toolbox {
  display: none;
}

.sc-launcher.opened :before {
  box-shadow: none;
}

.sc-launcher.opened:before {
  box-shadow: none !important;
}

.sc-chat-window {
  border: 1px solid lightgray !important;
  width: 520px !important;
  z-index: 5;
}

.sc-launcher {
  z-index: 5;
}

.sc-header {
  min-height: unset !important;
}

.sc-user-input {
  border-top: 1px solid lightgray !important;

}

.sc-user-input--text {
  width: 450px !important;
}

.sc-header--close-button {
  margin-left: 0 !important;
}

.my-body {
  padding: 0 !important;
}

.hidden_header {
  display: none;
}

.sc-user-input--file-icon-wrapper {
  margin-bottom: 0;
}
</style>

<style scoped>

.form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.p-center {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0;
}

.bold-text {
  font-weight: bold;
}

::placeholder { /* Firefox, Chrome, Opera */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
}

.icon-muted {
  cursor: initial !important;
  opacity: 0.3 !important;
}

.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
.label-horizontal {
  display: inline-flex;
  align-items: center;
  height: 35px;
}

::v-deep .custom-checkbox {
  min-width: 94px;
}

.cursor-pointer {
  cursor: pointer;
}

</style>
